/* eslint-disable no-console */
import qs from 'qs';

export function initialiseMegaMenuTagging(search = '') {
	if (window.digitalDataProxy) {
		const queryObj = qs.parse(search.substring(1));

		if (queryObj.hasOwnProperty('mmref')) {
			const [cat, subCat, text, pos] = queryObj.mmref.split('|');

			if (cat && text && pos) {
				const payload = {
					page: {
						megaMenu: {
							cat,
							subCat,
							text,
							pos
						}
					}
				};

				window.digitalDataProxy.manipulateDigitalData(payload);
			}
		}
	}
}

initialiseMegaMenuTagging(window.location.search);
